// Flatten a WorkflowFile record (as it comes out of an injected list /
// modelmeta response) into a predictable shape for plugins to match
// against. Host responsibility, so individual plugins don't have to
// re-derive how to pull a string out of a { name, value, category }
// wrapper — same concern also exists for the markdown / html viewers
// in WorkflowFilePreview itself.
//
// Shape plugins can rely on:
//
//   {
//     id,             // uuid string, or null
//     name,           // display filename, or ""
//     filePath,       // path inside the WorkflowVersion, or ""
//     dataType,       // machine value ("MAIN", "text/markdown", …) or ""
//     dataTypeLabel,  // human label, or ""
//     deleted,        // boolean
//     raw,            // the original record, for plugins that really do
//                     // need to look at something we didn't normalize
//   }

function unwrapField(field) {
  if (field == null) return undefined
  if (typeof field !== 'object') return field
  return 'value' in field ? field.value : field
}

function stringValue(field) {
  const v = unwrapField(field)
  return typeof v === 'string' ? v : undefined
}

function choiceValue(field) {
  const v = unwrapField(field)
  if (v && typeof v === 'object' && typeof v.value === 'string') return v.value
  return typeof v === 'string' ? v : undefined
}

function choiceLabel(field) {
  const v = unwrapField(field)
  if (v && typeof v === 'object' && typeof v.label === 'string') return v.label
  return undefined
}

function nameValue(field) {
  const v = unwrapField(field)
  if (typeof v === 'string') return v
  if (v && typeof v === 'object' && typeof v.name === 'string') return v.name
  return undefined
}

function boolValue(field) {
  const v = unwrapField(field)
  return typeof v === 'boolean' ? v : !!v
}

export function normalizeWorkflowFile(file) {
  if (!file || typeof file !== 'object') {
    return {
      id: null,
      name: '',
      filePath: '',
      dataType: '',
      dataTypeLabel: '',
      deleted: false,
      raw: file,
    }
  }
  return {
    id: stringValue(file.id) ?? null,
    name: nameValue(file.name) ?? '',
    filePath: stringValue(file.file_path) ?? '',
    dataType: choiceValue(file.data_type) ?? '',
    dataTypeLabel: choiceLabel(file.data_type) ?? '',
    deleted: boolValue(file.deleted),
    raw: file,
  }
}
